import { useEffect, useCallback } from "react";

const useClickEvent = (onClick) => {
  const handleClick = useCallback(
    (e) => {
      onClick(e);
    },
    [onClick]
  );

  useEffect(() => {
    window.addEventListener("click", handleClick);
    return () => {
      window.removeEventListener("click", handleClick);
    };
  }, [handleClick]);
};

export default useClickEvent;
